import { Box, Card, CardContent, Divider, Skeleton } from "@mui/material";
import { keyframes } from "@mui/material/styles";

const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

const shimmerStyles = {
  background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
  backgroundSize: "200% 100%",
  animation: `${shimmer} 1.5s ease-in-out infinite`,
};

export const PersonSummaryCardSkeleton = () => (
  <Card
    variant="outlined"
    sx={{
      borderRadius: 3,
      overflow: "hidden",
      height: "100%",
      bgcolor: "background.paper",
      boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
    }}
  >
    <CardContent
      sx={{
        p: { xs: 1.5, sm: 2 },
        "&:last-child": { pb: 2 },
      }}
    >
      {/* Profile image skeleton */}
      <Box
        sx={{
          position: "relative",
          width: "100%",
          aspectRatio: "1 / 1",
          borderRadius: 2,
          overflow: "hidden",
          mb: 1.5,
          ...shimmerStyles,
        }}
      >
        {/* Name and employee ID overlay */}
        <Box
          sx={{
            position: "absolute",
            left: 12,
            right: 12,
            bottom: 12,
            display: "flex",
            flexDirection: "column",
            gap: 0.5,
          }}
        >
          <Box
            sx={{
              width: "68%",
              height: 17,
              borderRadius: 1,
              bgcolor: "rgba(255,255,255,0.8)",
            }}
          />
          <Box
            sx={{
              width: "43%",
              height: 12,
              borderRadius: 1,
              bgcolor: "rgba(255,255,255,0.65)",
            }}
          />
        </Box>
      </Box>

      {/* Divider */}
      <Divider sx={{ mb: 1.25 }} />

      {/* Employee details */}
      <Box sx={{ mb: 1.5 }}>
        {[
          { id: 1, left: "28%", right: "43%" },
          { id: 2, left: "32%", right: "7%" },
          { id: 3, left: "30%", right: "34%" },
          { id: 4, left: "38%", right: "52%" },
        ].map((row) => (
          <Box
            key={row.id}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 1,
              mb: 1.1,
            }}
          >
            <Skeleton
              variant="text"
              animation="wave"
              sx={{
                width: row.left,
                height: 19,
                fontSize: "0.75rem",
                flexShrink: 0,
              }}
            />
            <Skeleton
              variant="text"
              animation="wave"
              sx={{
                width: row.right,
                height: 19,
                fontSize: "0.85rem",
              }}
            />
          </Box>
        ))}
      </Box>

      {/* Bottom action buttons */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          flexWrap: "nowrap",
        }}
      >
        <Skeleton
          variant="rounded"
          animation="wave"
          sx={{
            width: 64,
            height: 32,
            borderRadius: 1,
          }}
        />

        <Skeleton
          variant="rounded"
          animation="wave"
          sx={{
            width: 80,
            height: 32,
            borderRadius: 1,
          }}
        />

        <Skeleton
          variant="rounded"
          animation="wave"
          sx={{
            width: 98,
            height: 32,
            borderRadius: 1,
          }}
        />
      </Box>
    </CardContent>
  </Card>
);
